module.exports = __webpack_public_path__ + "img/icon-location.9c188b4b.svg";